import * as React from "react"
import * as cs from './SearchProductItemPc.module.scss'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/scss'


function SearchProductItem(props: any) {
  const { key, item, keyword } = props || {}
  const getName = () => {
    const firstSection = item?.searchProduct?.product.brandCN || item?.searchProduct?.product.displayBrand || item?.searchProduct?.product.brand
    const namePart = item.searchProduct?.product?.nameCN || item.searchProduct?.product?.name || item.nameCN || item.name
    if (firstSection) {
      return `${firstSection} | ${namePart}`
    }
    return namePart
  }

  const getTags = () => {
    const { labelView, off, activityOffs } = item?.searchProduct || {}
    const { shortLabels } = labelView || {}
    let tags: any[] = []
    if (shortLabels?.length) {
      const lbs = shortLabels.map((s: any) => s.labels)?.flat()?.map((lb: any) => lb.text)
      if (lbs?.length) {
        tags = [].concat(lbs)
      }
    }
    if (activityOffs?.length) {
      tags = tags.concat(activityOffs)
    }
    // if (off) {
    //   tags.push(off)
    // }
    return tags
  }

  const renderColors = () => {
    const { colors } = item.searchProduct?.product || {}
    // console.log(colors)
    if (!colors?.length || colors?.length < 2) return null
    return (
      <Swiper 
        slidesPerView={5}
        // onSwiper={setThumbsSwiper}
        freeMode
        watchSlidesProgress
        className={cs.categoryProductImgColors}
      >
        {
          colors?.map((color: any, index: number) =>(
            <SwiperSlide 
              key={index}
              className={
                `thumbs-swiper-item`
              }
            >
              <div 
                className="thumbs-slider-item-img"
              >
                <img src={color.image?.thumbnail?.url || color.image?.full.url} alt={`color ${color.name}, ${getName()}`} />
              </div>
            </SwiperSlide>
          ))
        }
      </Swiper>
    )
  }

  const tags = getTags()
  return (
    <a title={`${getName()}商品图片 ${tags?.join(', ')}`} key={key} className={cs.categoryProduct} href={`/pd/${item?.searchProduct?.product?.id}/`}>
      <div className={cs.categoryProductImg}>
        <img 
          src={item?.searchProduct?.product?.images?.[0]?.thumbnail?.url || item?.searchProduct?.product?.images?.[0]?.full?.url}
          alt={`${keyword}, ${getName()}商品图片 ${tags?.join(', ')}`}
        />
        {renderColors()}
      </div>
      <h2 className={cs.categoryProductName}>{getName()}</h2>
      <div className={cs.categoryProductOrigin}>
        {item.searchProduct.origin ? `${item.searchProduct.origin} `: ''}{item.searchProduct.merchantName}
      </div>
      <div className={cs.categoryProductPrice}>
        <span className={cs.categoryProductPriceCn}>{item.searchProduct.product.priceTagCN}</span>
        <span className={cs.categoryProductPriceEn}>{item.searchProduct.product.priceTag}</span>
      </div>
      <div className={cs.categoryProductTag}>
        {
          tags?.map((tag: string, index: number) => {
            return (
              <div key={index}>
                <span>{tag}</span>
                {(index === tags.length - 1) ? null : <span className={cs.categoryProductTagLine}></span>}
              </div>
            )
          })
        }
      </div>
    </a>
  )
}

export default SearchProductItem
